import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as EmailIcon } from 'images/email.svg';
import styled from 'styled-components';
import Paper from 'components/Paper';
import InlineButton from 'components/InlineButton';

const ResendPaper = styled(Paper)`
  display: flex;
  .resend-content {
    flex-grow: 1;
  }
  .image-container {
    svg {
      width: 100px;
      height: 100px;
    }
  }
`;

const ResendButton = styled(InlineButton)`
      color: ${({ theme }) => theme.palette.primary.main};
      padding: 0;
`;

const ResendWidget = ({ className, onResendClick }) => {
  const classes = ['ResendWidget'];
  if (className) classes.push(className);

  return (
    <ResendPaper className={classes.join(' ')}>
      <div className="resend-content">
        <h2>Need a new code?</h2>
        <p>email not showing up in your inbox or junk mail folder?</p>
        <ResendButton onClick={onResendClick}>Resend it</ResendButton>
      </div>
      <div className="image-container">
        <EmailIcon />
      </div>
    </ResendPaper>
  );
};

ResendWidget.displayName = 'ResendWidget';

ResendWidget.propTypes = {
  onResendClick: PropTypes.func,
  className: PropTypes.string,
};

ResendWidget.defaultProps = {
  onResendClick: null,
  className: null,
};

export default ResendWidget;
